// this has to be import or we have to require( 'firebase' ).default or browser breaks
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/database';
import common from './common.js';
import firebaseInit from './FirebaseStore.js';
common.registerDatabase('firebase', firebaseInit(firebase));
common.registerLib('firebase', firebase);
export default common;